import type { Prototype } from "../prototype-types";

export const shilpaSubrahmanyamPrototypes: Prototype[] = [
  {
    id: "find-similar-ad-modal",
    name: "Find Similar Ad Modal",
    path: "/ss/search/find-similar-ad-modal",
    description:
      "Exploring modal treatments to advertise the Find Similar feature on search results — centered dialog, bottom banner, inline callout card, and contextual tooltip variants.",
    owner: "Shilpa Subrahmanyam",
    createdAt: "2026-04-01",
    lastUpdated: "2026-04-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8b969f3ff9f82a23164d96c1e3d1cf3ec352981dcaf492623b97e8af9d45f5dc.png",
    creationTool: "cursor",
  },
  {
    id: "next-gen-search",
    name: "Next-Gen Search",
    path: "/ss/next-gen-search",
    description:
      "Exploring the synchrony of multiple changes to the current search query + results flow: query intent interpretation, inline suggestions, real-time result transitions, and query narrowing.",
    owner: "Shilpa Subrahmanyam",
    createdAt: "2026-03-14",
    lastUpdated: "2026-03-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e59ed56d7c74ffb5203362eb627cf4f5971fe65993d66e86a02b3c1bd8160a53.png",
    creationTool: "cursor",
  },
];
